export default {"src":"/_next/static/media/gh.fe2593ed.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};